export default RegExp.prototype.test.bind(/(<([^>]+)>)/i);
